import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VgOffCanvasBodyComponent, VgOffCanvasComponent, VgOffCanvasFooterComponent, VgOffCanvasHeaderComponent } from './vg-off-canvas.component';
import { VlIconModule } from 'vl-tailwind-layout';

const COMPONENTS = [
  VgOffCanvasComponent,
  VgOffCanvasHeaderComponent,
  VgOffCanvasBodyComponent,
  VgOffCanvasFooterComponent
]

@NgModule({
  imports: [
    CommonModule,
    VlIconModule
  ],
  declarations: [
    ...COMPONENTS
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class VgOffCanvasModule { }
